import React from 'react';
import Select from 'react-select';
import { Button } from '@/components/ui/button';
import { getMedcallStaffOptionLabel, MedcallStaffOption } from './medcallStaffOptions';
import './Medcall2StaffAssignmentForm.css';

export const Medcall2StaffAssignmentForm = ({
  currentUserId, history, onCancel, onChange, onSubmit, options, pending, value,
}: {
  currentUserId: number;
  history: Array<{ date?: string | null; fullname?: string | null; username?: string | null }>;
  onCancel: () => void;
  onChange: (value: string) => void;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  options: MedcallStaffOption[];
  pending: boolean;
  value: string;
}) => {
  const [tab, setTab] = React.useState('form');
  const [required, setRequired] = React.useState(false);
  const choices = options.map((option) => ({ value: `${option.id}`, label: getMedcallStaffOptionLabel(option) }));
  const tabs = [1, 2].includes(currentUserId) ? ['form', 'history'] : ['form'];
  return (
    <div className="medcall2-staff-assignment">
      <div className="medcall2-staff-assignment__tabs" role="tablist">
        {tabs.map((item) => (
          <button aria-selected={tab === item} className={tab === item ? 'is-active' : ''} id={`medcall2-staff-tab-${item}`} key={item} onClick={() => setTab(item)} role="tab" type="button">
            {item === 'form' ? 'Form' : 'History'}
          </button>
        ))}
      </div>
      {tab === 'form' ? (
        <form className="medcall2-staff-assignment__body" onSubmit={(event) => {
          event.preventDefault();
          if (!value) { setRequired(true); return; }
          onSubmit(event);
        }}>
          <div className="medcall2-staff-assignment__field">
            <label htmlFor="medcall2-staff-select"><span>*</span> Staff:</label>
            <div>
              <Select
                classNamePrefix="medcall2-staff-select"
                inputId="medcall2-staff-select"
                instanceId="medcall2-staff-select"
                isDisabled={pending}
                noOptionsMessage={() => 'No data'}
                onChange={(option: { label: string; value: string } | null) => { onChange(option?.value || ''); setRequired(false); }}
                options={choices}
                placeholder="Select Staff"
                value={choices.find((option) => option.value === value) || null}
              />
              {required ? <div className="medcall2-staff-assignment__error" role="alert">Please choose a name from the list.</div> : null}
            </div>
          </div>
          <div className="medcall2-legacy-assignment-dialog__footer">
            <Button disabled={pending} id="medcall2-staff-cancel" onClick={onCancel} type="button" variant="outline">Cancel</Button>
            <Button disabled={pending} id="medcall2-staff-submit" type="submit">Submit</Button>
          </div>
        </form>
      ) : (
        <div className="medcall2-staff-assignment__history" role="tabpanel">
          {history.length === 0 ? <div className="medcall2-staff-assignment__empty">No data</div> : (
            <>
              <div><strong>Name <i>(Username)</i></strong><strong>Unassigned At</strong></div>
              {history.map((item, index) => (
                <div key={index}>
                  <span>{item.fullname} (<i>{item.username}</i>)</span>
                  <span>{item.date?.replace(/^(\d{2})(\d{2})-(\d{2})-(\d{2})/, '$3/$4/$2')}</span>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};
